
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import {pathConstants} from "../../../shared/pathConstants";
import {helpers} from "@/shared/helper";
import Vue from "vue";

export const contractService = {
  fetchContracts,
  downloadAttachment
};

function fetchContracts(currentPage, perPage, sortBy = null, sortDir = null) {
    return axios
        .post(pathConstants.API + "/contract", {
            page: currentPage > 1 ? currentPage - 1 : 0,
            size: perPage,
            defaultSort: sortBy,
            defaultOrder: sortDir
        })
        .then(result => {
                return result.data;
            }, err => {
            Vue.$log.error("fetchContracts", err);
        });
}

function downloadAttachment(source, name) {
    return axios({
            url: pathConstants.API + '/contract/download',
            data: {source: source, name: name},
            method: 'POST',
            responseType: 'blob',
            showLoader: false
        }).then((response) => {
            helpers.downloadFile(response);
        });
}
